// This configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

import { AppVariables } from "./app-variables/types";

export default function initializeSentry(appVariables?: AppVariables) {
  if (!appVariables || !appVariables.SENTRY_DSN || Sentry.isInitialized()) {
    return;
  }

  Sentry.init({
    dsn: appVariables.SENTRY_DSN,
    environment: appVariables.APP_ENV,
    release: appVariables.NEXT_PUBLIC_RELEASE_NAME,
  });
}
